import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  left: 16px;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray400);
  z-index: 10;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`
